import {
    Dimensions,
    StyleProp,
    StyleSheet,
    TouchableOpacity,
    ViewStyle,
} from 'react-native';
import GradientContainer from './gradients/GradientContainer';
import React from 'react';
import { mbShadow } from '@mightybyte/rnw.utils.style-utils';
import { getTopInset, hitSlop } from '../../utils/shared';
import ArrowLeft from '../../resources/svgComponents/ArrowLeft';
import { useNavigation } from '@react-navigation/core';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { RootStackParamList } from '../../navigations/RootNavigator';
import { AnimatedView } from '../../utils/animations';
import { Overlay } from './Overlay';
import { RandomStars } from './RandomStars';

type OverviewScreenProps = {
    topSectionStyle?: StyleProp<ViewStyle>;
    topSectionChildren?: React.ReactChild;
    bottomSectionStyle?: StyleProp<ViewStyle>;
    children?: React.ReactNode;
    gradientColors?: [string, string];
    showBackBtn?: boolean;
    topSectionAnimated?: boolean;
    bottomSectionAnimated?: boolean;
    starsAnimated?: boolean;
    overlay?: boolean;
};

export default function OverviewScreen({
    topSectionStyle,
    topSectionChildren,
    bottomSectionStyle,
    children,
    gradientColors,
    showBackBtn,
    topSectionAnimated = false,
    bottomSectionAnimated = false,
    starsAnimated = false,
    overlay,
}: OverviewScreenProps) {
    const navigation =
        useNavigation<NativeStackNavigationProp<RootStackParamList>>();
    const { width, height } = Dimensions.get('window');

    return (
        <GradientContainer
            style={styles.container}
            angle={-90}
            colors={gradientColors}
        >
            <RandomStars
                enabled={starsAnimated}
                numberOfStars={12}
                height={height / 2}
                width={width}
                minSize={15}
                maxSize={40}
                numberOfRows={4}
                numberOfColumns={3}
                style={styles.star}
            />
            <AnimatedView
                enabled={topSectionAnimated}
                fromHeight="100%"
                toHeight={StyleSheet.flatten(topSectionStyle)?.height ?? '50%'}
                style={[styles.topSection, topSectionStyle]}
            >
                {topSectionChildren}
                {showBackBtn && (
                    <TouchableOpacity
                        hitSlop={hitSlop}
                        style={styles.backBtn}
                        onPress={navigation.goBack}
                    >
                        <ArrowLeft />
                    </TouchableOpacity>
                )}
            </AnimatedView>
            <AnimatedView
                enabled={bottomSectionAnimated}
                fromTranslateY={Dimensions.get('window').height / 2}
                toTranslateY={0}
                style={[styles.bottomSection, bottomSectionStyle]}
            >
                {children}
            </AnimatedView>
            {overlay && <Overlay />}
        </GradientContainer>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    topSection: {
        height: '50%',
        paddingTop: getTopInset(),
    },
    bottomSection: {
        borderTopLeftRadius: 36,
        borderTopRightRadius: 36,
        backgroundColor: '#EEEEF2',
        paddingTop: 30,
        height: '50%',
        ...mbShadow({
            offsetWidth: -5,
            offsetHeight: 0,
            color: '#000000',
            opacity: 0.15,
            radius: 10,
            elevation: 2,
        }),
    },
    backBtn: {
        position: 'absolute',
        left: 20,
        top: getTopInset(),
    },
    star: {
        zIndex: -1,
    },
});
